import htmlTags from 'html-tags';

export function isZyTag(name: string): boolean {
    if (!name) return false;
    return name.toLowerCase().startsWith('zy');
}

export function isValidHtmlTag(name: string): boolean {
    const tagsSet = new Set<string>(htmlTags.map(t => t.toLowerCase()));
    if (!name) return false;
    return tagsSet.has(name.toLowerCase());
}
